const $body = theme.$body;

function addClickCatcher() {
    $body.removeClass('mouse-enabled');
    if (!$('.mouse-catcher').length) {
        $body.append('<div class="mouse-catcher"></div>');
        $('.mouse-catcher').on('click mousemove', function () {
            $body.addClass('mouse-enabled');
            $(this).remove();
        });
    }
}

// Setup Click catchers (for focus outlines)
$body.addClass('mouse-enabled');
$body.keydown(function (e) {
    if (e.keyCode == '9') {
        addClickCatcher();
    }
});
